import { env } from 'env';

export enum RouteBasePaths {
  Index = '/',
  Logout = '/logout',
  HealthCheck = '/healthcheck',
  AcceptInvitation = '/accept',
  Appointments = '/appointments',
  Board = '/board',
  Conversations = '/conversations',
  Team = '/team',
  VideoCall = '/video-call',
  Settings = '/settings',
  Automations = '/automations',
  MessageTemplates = '/templates',
  Forms = '/forms',
  Demo = '/demo',
  Reporting = '/reporting',
  DisputesReporting = '/reporting/payments?tab=disputes',
  EmailCampaigns = '/emails',
  OttoEmailCampaigns = '/email-campaigns',
  EmailTemplates = '/email-templates',
  DevTools = '/devtools',
  TokenLogin = '/tokenlogin',
  Survey = '/survey',
  Impersonate = '/impersonate',
  LoyaltyProgram = '/loyalty-program',
  SuccessCenter = '/success-center',
  Support = '/support',
  GlobalAutomations = '/global-automations',
  Tasks = '/tasks',
}

export enum SettingsRoutes {
  Index = '/',
  ClinicGeneral = `/clinic/general`,
  ClinicHours = `/clinic/hours`,
  ClinicAutomations = '/clinic/automations',
  ClinicTeam = '/clinic/team',
  ClinicSubscription = '/clinic/subscription',
  ClinicPhone = '/clinic/phone',
  ClinicPayment = '/clinic/payment',
  ClinicWidget = '/clinic/widget',
  ClinicReminders = '/clinic/reminders',
  ClinicPostcards = '/clinic/postcards',
  Appointments = '/clinic/appointments',
  ClinicConversations = '/clinic/conversations',
  Tasks = '/clinic/tasks',
  UserProfile = '/user/profile',
  UserNotifications = '/user/notifications',
  UserPreferences = '/user/preferences',
  DevTools = '/devtools',
  ClinicBilling = '/clinic/billing',
  OttoLabs = '/otto-labs',
  SyncStatus = '/clinic/sync-status',
  GlobalAutomations = '/global-automations',
}

export const RouteDefinitions = {
  Index: RouteBasePaths.Index,
  HealthCheck: RouteBasePaths.HealthCheck,
  TokenLogin: `${RouteBasePaths.TokenLogin}/:token`,
  AcceptInvitation: `${RouteBasePaths.AcceptInvitation}/:invitationCode`,
  Appointments: `${RouteBasePaths.Appointments}`,
  Board: RouteBasePaths.Board,
  Conversations: `${RouteBasePaths.Conversations}/:channelId?`,
  ChannelMessageAttachments: `/channelattachments/:channelMessageAttachmentId?`,
  Team: `${RouteBasePaths.Team}/:channelId?`,
  VideoCall: `${RouteBasePaths.VideoCall}/:channelId`,
  Settings: RouteBasePaths.Settings,
  Automations: `${RouteBasePaths.Automations}/:workflowEventSettingId?/:automationEditorView?`,
  MessageTemplates: `${RouteBasePaths.MessageTemplates}/:messageTemplateId?`,
  Forms: `${RouteBasePaths.Forms}/:formTemplateId?`,
  DemoWorkflow: `${RouteBasePaths.Demo}/workflow`,
  Reporting: RouteBasePaths.Reporting,
  EmailCampaigns: RouteBasePaths.EmailCampaigns,
  EmailTemplates: RouteBasePaths.EmailTemplates,
  Login: `${env.REACT_APP_LOGIN_URL}`,
  Logout: RouteBasePaths.Logout,
  Impersonate: `${RouteBasePaths.Impersonate}/:token`,
  Survey: RouteBasePaths.Survey,
  LoyaltyProgram: RouteBasePaths.LoyaltyProgram,
  SuccessCenter: `${RouteBasePaths.SuccessCenter}`,
  Support: RouteBasePaths.Support,
  OttoEmailCampaigns: `${RouteBasePaths.OttoEmailCampaigns}/:campaignId?/:campaignAction?`,
  GlobalAutomations: `${SettingsRoutes.GlobalAutomations}/:workflowEventSettingId?/:automationEditorView?`,
  Tasks: RouteBasePaths.Tasks,
};
